<template>
  <div class="adminPage">
    <el-container style="height: 100%; border: 1px solid #eee">
      <el-aside width="200px" class="leftInfo">
        <div class="logo">
          <div class="logoInfo" style="margin-top: 30px">
            <img src="../../assets/logo.png" width="167px" height="107px">
          </div>

          <div style="height: 5px">
          </div>
        </div>
        <el-menu style="width: 200px; text-align: left; " default-active="/admin/syzy"
                 class="el-menu-vertical-demo"
                 text-color="#fff"
                 router
                 active-text-color="#3c57c4">
          <el-menu-item-group>
           <!-- <el-menu-item index="/admin/sy">
              <i class="el-icon-s-home"></i>
              <span slot="title">首页</span>
            </el-menu-item>-->
            <el-menu-item index="/admin/syzy">
              <i class="el-icon-document" style="font-size: 18px"></i>
              <span slot="title" style="font-size: 18px">实验简介</span>
            </el-menu-item>
            <el-menu-item index="/admin/dzs">
              <i class="el-icon-aim" style="font-size: 18px"></i>
              <span slot="title" style="font-size: 18px">实验目标</span>
            </el-menu-item>
            <el-menu-item index="/admin/lwflgl">
              <i class="el-icon-s-operation" style="font-size: 18px"></i>
              <span slot="title" style="font-size: 18px">实验管理</span>
            </el-menu-item>
            <el-menu-item index="/admin/sp">
              <i class="el-icon-setting" style="font-size: 18px"></i>
              <span slot="title" style="font-size: 18px">实验成绩</span>
            </el-menu-item>
            <el-menu-item index="/admin/jc">
              <i class="el-icon-notebook-2" style="font-size: 18px"></i>
              <span slot="title" style="font-size: 18px">配套教材</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-menu>
      </el-aside>

      <el-container>
        <el-header style="font-size: 12px" class="topInfo">
          <el-row :gutter="24">

            <el-col :span="16">
              <div style="height: 70px;display: flex;align-items: center;">
                <img src="../../assets/Python.png" width="40px" height="40px">
                <div style="font-size: 18px; margin-left: 10px; color: white"> Python函数参数传递可视化虚拟仿真实验</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div style="height: 80px;font-size: 20px; text-align: right; font-weight: bold; color: white; cursor: pointer"
                   @click="logout">
                <i class="el-icon-switch-button" style="margin-right: 25px">
                  <span style="margin-left: 5px; font-size: 17px; color: white">退出</span>
                </i>
              </div>
            </el-col>
          </el-row>
        </el-header>
        <el-main style="padding: 0px; background-color: #212f52;">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: 'ADMIN',
    data() {
      const item = {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      };
      return {
        tableData: Array(20).fill(item)
      }
    },
    methods: {
      logout() {
        localStorage.removeItem("token");
        // 管理员页面
        this.$router.push('/');
      },
    },
    mounted() {
      this.$router.push('/admin/syzy')
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .adminPage {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    overflow: hidden;
  }

  .el-header {
    background-color: white;
    color: #333;
    line-height: 60px;
  }

  .topInfo {
    background-image: url("../../assets/topbg.png");
  }

  .leftInfo {
    background-image: url("../../assets/leftbg.png");
  }

  .el-menu-vertical-demo {
    background: none;

  }

  .el-aside {
    height: 100vh;
    color: #333;
    background-color: #00275B;
    overflow-x: hidden;
  }

  .logo {
    width: 199px;
    /*background-color: #00275B;*/
  }

  .el-main {
    overflow: hidden;
  }

  .el-tabs__content {
    height: calc(100vh - 176px);
    overflow-y: auto;
  }

  .el-menu-item:hover {
    background-color: #3c57c4;
  }

  .el-menu-item:focus {
    background-color: #00275b;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Admin.vue